<template>
  <div
    class="content-between p-2"
    style="border-bottom: 1px solid #e4e4e4"
    v-if="lineLayout == 'Compact'"
  >
    <div class="f-2xl f-bold">แก้ไขข้อมูลส่วนตัว</div>
    <div class="cursor-pointer f-2xl" @click="$router.push('/manage')">
      <font-awesome-icon :icon="['fas', 'times']" />
    </div>
  </div>

  <div v-if="isLoading">
    <OtherLoading variant="dark" />
  </div>

  <template v-else>
    <v-tabs v-model="tabIndex" grow>
      <v-tab class="tabs-with-button" value="0" id="profile-genral-form">
        {{ $t("profile_general") }}
      </v-tab>
      <v-tab
        class="tabs-with-button"
        title="ข้อมูลเพิ่มเติม"
        v-if="dynamicField.length != 0"
        value="1"
        id="profile-additional-form"
      >
        {{ $t("profile_additional") }}
      </v-tab>
      <v-tab
        class="tabs-with-button"
        value="2"
        v-if="!componentKey && $config.address_per_unit != ''"
        id="billing-form"
      >
        {{ $t("billing") }}
      </v-tab>
      <v-tab
        class="tabs-with-button"
        value="3"
        id="shipping-form"
        v-if="!componentKey && $config.address_per_unit != ''"
      >
        {{ $t("shipping") }}
      </v-tab>
      <v-tab
        class="tabs-with-button"
        value="4"
        id="contact-form"
        v-if="!componentKey && $config.address_per_unit != ''"
      >
        {{ $t("contact") }}
      </v-tab>
      <template v-if="!componentKey">
        <v-tab
          class="container-tabs"
          v-for="tabs of customObjectForm"
          :key="'customObject-' + tabs.id"
          @click="handleTabsChange(tabs.name)"
          :value="'customObject-' + tabs.id"
        >
          {{ tabs.name }}
        </v-tab>
        <v-tab
          class="container-tabs"
          v-for="tabs of customObjectForm"
          :key="'customObject-' + tabs.id"
          @click="handleTabsChange(tabs.name)"
          :value="'customObject-' + tabs.id"
        >
          {{ tabs.name }}
        </v-tab>
      </template>
    </v-tabs>

    <v-window v-model="tabIndex">
      <v-window-item class="window-padding" value="0" :disabled="true">
        <div class="content-edit-profile">
          <template v-if="!isAddOptionalTelephone">
            <v-expansion-panels flat v-model="panels" multiple>
              <v-expansion-panel bg-color="white">
                <v-expansion-panel-title
                  static
                  hide-actions
                  flat
                  class="px-3 py-0"
                  id="profile_general"
                >
                  <template #default="{ expanded }">
                    <div class="content-between w-100">
                      <div class="f-xl f-bold">
                        {{ $t("profile_general") }}
                      </div>
                      <div>
                        <font-awesome-icon
                          :icon="['fas', 'chevron-up']"
                          v-if="expanded"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'chevron-down']"
                          v-else
                        />
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text eager>
                  <div
                    v-html="$config.header_edit_profile_form"
                    class="px-3"
                    v-if="$config.header_edit_profile_form"
                  ></div>
                  <ProfileForm
                    :fields="customField.filter(el => el.group_id == 1)"
                    :v$="v$"
                    :form="form"
                    @addOptionalTelephone="addOptionalTelephone"
                    :saveIDCard="saveIDCard"
                    :componentKey="componentKey"
                    :birthDayFirst="birthDayFirst"
                  />
                </v-expansion-panel-text>
              </v-expansion-panel>
              <v-expansion-panel
                bg-color="white"
                v-if="customField.filter(el => el.group_id == 2).length > 0"
              >
                <v-expansion-panel-title
                  static
                  hide-actions
                  flat
                  class="px-3 py-0"
                  id="profile_address"
                >
                  <template #default="{ expanded }">
                    <div class="content-between w-100">
                      <div class="f-xl f-bold">
                        {{ $t("profile_address") }}
                      </div>
                      <div>
                        <font-awesome-icon
                          :icon="['fas', 'chevron-up']"
                          v-if="expanded"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'chevron-down']"
                          v-else
                        />
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text eager>
                  <ProfileForm
                    :fields="customField.filter(el => el.group_id == 2)"
                    :v$="v$"
                    :form="form"
                  />
                </v-expansion-panel-text>
              </v-expansion-panel>
              <v-expansion-panel bg-color="white" v-if="socialField.length > 0">
                <v-expansion-panel-title
                  static
                  hide-actions
                  flat
                  class="px-3 py-0"
                  id="social_media"
                >
                  <template #default="{ expanded }">
                    <div class="content-between w-100">
                      <div class="f-xl f-bold" data-lang="social_media">
                        {{ $t("social_media") }}
                      </div>
                      <div>
                        <font-awesome-icon
                          :icon="['fas', 'chevron-up']"
                          v-if="expanded"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'chevron-down']"
                          v-else
                        />
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text eager>
                  <DynamicForm
                    class="px-3"
                    :fields="socialField"
                    :v$="v$"
                    keyFormValidate="socialField"
                  />
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-row class="mt-3 px-3">
              <PrivacyPolicyCheckbox
                v-if="!consentShow && !$isMinimalCompact"
                type="term"
                v-model="form.is_consent"
                :login-type="form.login_type"
                checkbox-id="policy-checkbox"
              />
              <ConsentItem
                v-for="items of consentList"
                :key="`${items.id}-${items.name}`"
                :item="items"
              />
            </v-row>
          </template>
          <OptionalTelephone
            v-else
            :form="form"
            :canEdit="optionalField.allow_customer_edit"
            @saveOptionalTelephone="saveOptionalTelephone"
            @close="closeOptionalTelephone"
          />
        </div>

        <template v-if="!isAddOptionalTelephone">
          <div
            v-html="$config.footer_edit_profile_form"
            class="px-3 mt-3"
            v-if="$config.footer_edit_profile_form"
          ></div>
          <div v-if="lineLayout == 'Compact'" class="p-3">
            <div
              class="text-underline cursor-pointer pr-2 text-gray mb-2"
              @click.prevent="modalTermsOpen"
            >
              {{ $t("term") }}
            </div>
            <div
              class="text-underline cursor-pointer text-gray mb-2"
              @click.prevent="modalPolicyOpen"
            >
              {{ $t("policy") }}
            </div>

            <div
              v-if="$route.query.pdpa !== '4' && displayRightRequest"
              class="text-underline cursor-pointer text-gray mb-2"
              @click="handleLink"
            >
              {{ $t("pdpa") }}
            </div>
          </div>
          <v-row class="text-center m-2" v-else>
            <v-col class="consent-text">
              <div>
                <span
                  class="text-underline cursor-pointer pr-2"
                  @click.prevent="modalTermsOpen"
                >
                  {{ $t("term") }}</span
                >
                <span
                  class="text-underline cursor-pointer"
                  @click.prevent="modalPolicyOpen"
                >
                  {{ $t("policy") }}</span
                >
              </div>
              <div v-if="$route.query.pdpa !== '4' && displayRightRequest">
                <span class="text-underline cursor-pointer" @click="handleLink">
                  {{ $t("pdpa") }}</span
                >
              </div>
            </v-col>
          </v-row>
        </template>
      </v-window-item>

      <v-window-item class="window-padding" value="1" :disabled="true">
        <DynamicForm
          class="p-3"
          :fields="dynamicField"
          :v$="v$"
          isEdit
          :cloneFieldDynamic="cloneFieldDynamic"
        />
      </v-window-item>
      <v-window-item class="window-padding" value="2" :disabled="true">
        <InvoiceAddress v-if="tabIndex == 2" />
      </v-window-item>
      <v-window-item class="window-padding" value="3" :disabled="true">
        <ShippingAddress v-if="tabIndex == 3" />
      </v-window-item>
      <v-window-item class="window-padding" value="4" :disabled="true">
        <ContactAddress v-if="tabIndex == 4" />
      </v-window-item>
      <v-window-item
        v-for="tabs of customObjectForm"
        :key="'customObject-' + tabs.id"
        @click="handleTabsChange(tabs.name)"
        :value="'customObject-' + tabs.id"
        :disabled="true"
      >
        <PreviewCustomObject
          v-if="tabIndex == `customObject-${tabs.id}`"
          :formId="tabs.id"
          :tabsName="tabsName"
          :isFull="
            tabs.user_limit != 0 ? tabs.user_ans >= tabs.user_limit : false
          "
          @fetching="getCustomObjectForm"
        />
      </v-window-item>

      <div
        class="register-bottom fixed-bottom"
        :class="{ 'bg-white': !lineLayout.includes('Minimal') }"
        v-if="(tabIndex == 0 || tabIndex == 1) && !isAddOptionalTelephone"
      >
        <c-btn
          class="w-100"
          @click="nextPage()"
          variant="confirm-primary"
          v-if="tabIndex == 0"
          :disabled="disabledBtn || !isConsentError"
          >{{ dynamicField.length == 0 ? $t("save") : $t("next_page") }}</c-btn
        >
        <c-btn
          class="w-100"
          @click="validateEmail()"
          v-else-if="tabIndex == 1"
          variant="confirm-primary"
          :disabled="disabledBtn || isDisabledButton || !isConsentError"
        >
          {{ $t("save") }}
        </c-btn>
      </div>
    </v-window>
    <ModalPolicy ref="modalPolicy" />
    <ModalTermAndConditios ref="modalTerms" />
  </template>
  <ModalError ref="modalError" :text="successMessage" />
</template>

<script>
import ModalError from "@/components/alert-modal/ModalError";
const moment = require("moment");
import OtherLoading from "@/components/other/OtherLoading";
import ModalPolicy from "@/components/alert-modal/ModalPolicy";
import ModalTermAndConditios from "@/components/alert-modal/ModalTermAndConditios";
import { fieldInForm2 } from "@/assets/json/fieldProfile.js";
import ProfileForm from "@/components/form/ProfileForm.vue";

import PreviewCustomObject from "@/views/page/customForm/detail.vue";
import DynamicForm from "@/components/form/DynamicForm.vue";
import OptionalTelephone from "@/components/form/OptionalTelephone.vue";
import InvoiceAddress from "@/components/form/InvoiceAddress";
import ShippingAddress from "@/components/form/ShippingAddress";
import ContactAddress from "@/components/form/ContactAddress";
import ConsentItem from "@/components/profile/edit/ConsentItem.vue";
import PrivacyPolicyCheckbox from "@/components/profile/edit/PrivacyPolicyCheckbox.vue";
export default {
  components: {
    ModalError,
    OtherLoading,
    ModalPolicy,
    ModalTermAndConditios,
    PreviewCustomObject,
    ProfileForm,
    DynamicForm,
    OptionalTelephone,
    InvoiceAddress,
    ShippingAddress,
    ContactAddress,
    ConsentItem,
    PrivacyPolicyCheckbox
  },
  props: {
    form: {
      required: true,
      type: Object
    },

    hideTerm: {
      required: false
    },
    consentShow: {
      required: true,
      type: Boolean
    },
    customField: {
      required: true,
      type: Array
    },
    questionList: {
      required: true,
      type: Array
    },
    v$: {
      required: true,
      type: Object
    },
    isEdit: {
      required: true,
      type: Boolean,
      default: false
    },
    dynamicField: {
      required: false
    },
    socialField: {
      required: false,
      type: Array
    },
    hasSubmit: {
      required: false,
      default: false
    },

    isDisabledButton: {
      required: false
    },
    saveIDCard: {
      required: false
    },
    componentKey: {
      required: false,
      type: Boolean,
      default: false
    },
    consentList: {
      required: false
    },
    birthDayFirst: {
      required: false,

      default: ""
    }
  },
  data() {
    return {
      successMessage: "",
      emailFirst: "",
      disabledBtn: false,
      displayRightRequest:
        this.$store.state.theme.line_display_right_request_link == "1"
          ? true
          : false,
      day: [
        { value: "01", title: "01", disabled: false },
        { value: "02", title: "02", disabled: false },
        { value: "03", title: "03", disabled: false },
        { value: "04", title: "04", disabled: false },
        { value: "05", title: "05", disabled: false },
        { value: "06", title: "06", disabled: false },
        { value: "07", title: "07", disabled: false },
        { value: "08", title: "08", disabled: false },
        { value: "09", title: "09", disabled: false },
        { value: "10", title: "10", disabled: false },
        { value: "11", title: "11", disabled: false },
        { value: "12", title: "12", disabled: false },
        { value: "13", title: "13", disabled: false },
        { value: "14", title: "14", disabled: false },
        { value: "15", title: "15", disabled: false },
        { value: "16", title: "16", disabled: false },
        { value: "17", title: "17", disabled: false },
        { value: "18", title: "18", disabled: false },
        { value: "19", title: "19", disabled: false },
        { value: "20", title: "20", disabled: false },
        { value: "21", title: "21", disabled: false },
        { value: "22", title: "22", disabled: false },
        { value: "23", title: "23", disabled: false },
        { value: "24", title: "24", disabled: false },
        { value: "25", title: "25", disabled: false },
        { value: "26", title: "26", disabled: false },
        { value: "27", title: "27", disabled: false },
        { value: "28", title: "28", disabled: false },
        { value: "29", title: "29", disabled: false },
        { value: "30", title: "30", disabled: false },
        { value: "31", title: "31", disabled: false }
      ],
      month: [
        { value: "01", title: "มกราคม", disabled: false },
        { value: "02", title: "กุมภาพันธ์", disabled: false },
        { value: "03", title: "มีนาคม", disabled: false },
        { value: "04", title: "เมษายน", disabled: false },
        { value: "05", title: "พฤษภาคม", disabled: false },
        { value: "06", title: "มิถุนายน", disabled: false },
        { value: "07", title: "กรกฎาคม", disabled: false },
        { value: "08", title: "สิงหาคม", disabled: false },
        { value: "09", title: "กันยายน", disabled: false },
        { value: "10", title: "ตุลาคม", disabled: false },
        { value: "11", title: "พฤศจิกายน", disabled: false },
        { value: "12", title: "ธันวาคม", disabled: false }
      ],
      isLoading: false,
      tabIndex: null,
      customObjectForm: [],
      tabsName: "",
      fromDateMenu: false,
      fromDateVal: null,
      panels: [0, 1, 2],
      isAddOptionalTelephone: false,
      cloneFieldDynamic: []
    };
  },
  created() {
    this.emailFirst = this.form.email;
    this.handleMonth(this.form.birthday_month);
    this.handleDayChange(this.form.birthday_day);
    this.getCustomObjectForm();
    this.cloneFieldDynamic = JSON.parse(JSON.stringify(this.form.custom_field));
  },
  computed: {
    optionalField() {
      return this.customField.find(el => el.field_profile_type_id == 22) || {};
    },
    isConsentError() {
      let check = this.consentList
        .filter(el => el.is_required_in_edit_profile)
        .every(el => el.is_consent == 1);
      if (check) this.consentError = false;
      return check;
    }
  },
  watch: {
    tabIndex(val) {
      if (this.isAddOptionalTelephone)
        return (this.isAddOptionalTelephone = false);
    }
  },
  updated: function () {
    var $this = this;

    if (this.$route.query.id)
      this.$nextTick(function () {
        let index = $this.customObjectForm.findIndex(
          el => el.id == $this.$route.query.id
        );
        if (index != -1) {
          $this.tabIndex = `customObject-${$this.customObjectForm[index].id}`;
          $this.tabsName = $this.customObjectForm[index].name;
          return $this.$router
            .replace(
              `/manage/profile?check=true${
                this.$route.query.view ? "&view=" + this.$route.query.view : ""
              } `
            )
            .catch(err => {});
        }
      });
  },
  methods: {
    saveOptionalTelephone(val) {
      this.form.optional_telephone = val.join(",");
      this.isAddOptionalTelephone = false;
    },
    addOptionalTelephone() {
      this.isAddOptionalTelephone = true;
    },
    closeOptionalTelephone() {
      this.isAddOptionalTelephone = false;
    },
    resetForm() {
      this.v$.dynamicField.$reset();
    },

    handleMonth(vals) {
      let length = this.day.length - 1;
      let disabledMonth = ["04", "06", "09", "11"];
      if (vals == "02") {
        this.day[length].disabled = true;
        this.day[length - 1].disabled = true;
      } else if (disabledMonth.includes(vals)) {
        this.day[length].disabled = true;
        this.day[length - 1].disabled = false;
      } else {
        this.day[length].disabled = false;
        this.day[length - 1].disabled = false;
      }
    },
    handleDayChange(vals) {
      let disabledMonth = ["04", "06", "09", "11"];
      if (vals == 30 || vals == 31) {
        if (vals == 31) {
          this.$nextTick(() => {
            this.month.map(el => {
              if (disabledMonth.includes(el.value)) {
                el.disabled = true;
              }
              return { ...el };
            });
            this.month = this.month;
          });
        } else if (vals == 30) {
          this.month.map(el => {
            el.disabled = false;
            return { ...el };
          });
        }
        this.$nextTick(() => {
          this.month[1].disabled = true;
        });
      } else {
        this.month.map(el => {
          el.disabled = false;
          return { ...el };
        });
      }
    },

    handleLink() {
      if (this.$store.state.theme.is_right_request_url == "1")
        return window.open(this.$store.state.theme.right_request_url, "_blank");

      this.$router.push("/setting");
    },
    checkFieldConditon(obj) {
      return obj.field_conditions[0] ? obj.field_conditions[0].value : "text";
    },
    checkIsProfile(val) {
      const findField = fieldInForm2.find(el => el.id == val);

      return findField ? findField.key : false;
    },
    checkMaxMin(item, key, field_id) {
      if (field_id == 9) {
        const condition = item.find(el => el.field_condition_type_id == 7);

        if (condition)
          if (key == 3) {
            return condition.value
              ? this.$moment()
                  .subtract(condition.value, "year")
                  .format("YYYY-01-01")
              : false;
          } else if (key == 4) return this.$moment().format("YYYY-MM-DD");
      }
      const conditon = item.find(el => el.field_condition_type_id == key);
      if (conditon) return conditon.value ? conditon.value : false;
      return false;
    },
    isMaxMin: function (value, e) {
      try {
        const val = e.target.value;

        const max = Number(e.target.max);
        const min = Number(e.target.min);
        if (val && e.target.type == "number" && min && val < min) {
          return (e.target.value = min);
        }
        if (val && e.target.type == "number" && max && val > max) {
          return (e.target.value = max);
        }
      } catch (error) {
        console.log(error);
      }
    },
    isNumber: function (e) {
      const maxlen = e.target.maxLength;
      const val = e.target.value;

      if (
        (e.key == "e" || e.charCode == 45 || e.charCode == 46) &&
        e.target.type == "number"
      ) {
        return e.preventDefault();
      }
      if (maxlen == -1) {
        return val;
      }

      if (val.length > maxlen - 1) {
        return e.preventDefault();
      }
    },
    handleChangeGender(val) {
      this.form.gender = val;
    },
    dateFormat() {
      let today = new Date();
      return this.$moment(today).format();
    },
    async nextPage() {
      // this.v$.form.$touch();

      this.v$.form.$touch();
      this.v$.socialField.$touch();

      if (this.v$.form.$error || this.v$.socialField.$error) {
        return;
      }
      if (this.dynamicField.length == 0) {
        return this.validateEmail();
      }
      this.tabIndex = 1;
    },
    async validateEmail() {
      if (this.hasSubmit) {
        return this.$emit("onSubmit");
      }

      if (this.form.email !== this.emailFirst) {
        this.v$.form.$touch();
        if (this.v$.form.$error) {
          return;
        }

        let chkEmail = {
          Email: this.form.email
        };
        this.isLoading = true;
        try {
          this.$axios
            .post(`/api/v1/user/ValidateEmail`, chkEmail)
            .then(data => {
              if (data.result == 1) {
                this.validationFormEdit();
              } else {
                this.isLoading = false;
                if (this.$isMinimalProfile)
                  return this.$store.commit("setEmailDuplicate", true);
                this.successMessage = "Email นี้เคยสมัครแล้ว";
                this.$refs.modalError.show();
              }
            })
            .catch(error => {
              this.isLoading = false;
              if (this.$isMinimalProfile)
                return this.$store.commit("setEmailDuplicate", true);
              this.successMessage = "Email นี้เคยสมัครแล้ว";
              this.$refs.modalError.show();
            });
        } catch (error) {
          // this.successMessage = "Email นี้เคยสมัครแล้ว";
          // this.$refs.modalError.show();
          // this.isLoading = false;
          // console.log(error.message);
        }
      } else {
        this.validationFormEdit();
      }
    },
    isOtherField($fields) {
      if ($fields) {
        let find = $fields.field_choices
          ? $fields.field_choices.find(
              el =>
                el.name ==
                this.form[this.checkIsProfile($fields.field_profile_type_id)]
            )
          : null;
        return find ? (find.choice_type_id == 3 ? true : false) : false;
      }
    },
    async validationFormEdit() {
      this.v$.form.$touch();

      this.v$.dynamicField.$touch();
      this.v$.socialField.$touch();

      if (
        this.v$.dynamicField.$error ||
        this.v$.form.$error ||
        this.v$.socialField.$error
      ) {
        return;
      }

      let dynamic = [];
      for (const fields of this.dynamicField) {
        let target_id = 0;
        if (fields.field_choices.length > 0) {
          const findFieldId = fields.field_choices.find(
            choice => choice.name == fields.user_answer
          );
          if (findFieldId) {
            target_id = findFieldId.id;
          }
        }
        dynamic.push({
          id: fields.id,
          value: fields.user_answer,
          target_id: target_id
        });
      }
      let objTemp = [];

      for (const x of dynamic) {
        var findField = this.dynamicField.find(field => field.id == x.id);

        if (x.value && typeof x.value == "object") {
          if (x.value.length > 0) {
            for (const a of x.value) {
              const { id } = findField.field_choices.find(
                choice => choice.name == a
              );
              objTemp.push({
                id: x.id,
                value: a,
                target_id: id
              });
            }
          }
        } else {
          objTemp.push(x);
        }
      }

      this.isLoading = true;

      this.disabledBtn = true;

      delete this.form.birthday;

      let payload = {
        ...this.form,
        user_additional_consent_insert_List: this.consentList.map(el => {
          return { additional_consent_id: el.id, is_consent: el.is_consent };
        }),
        custom_field: objTemp.filter(el => el.value)
      };

      for (const checkForm of this.customField) {
        if (this.isOtherField(checkForm))
          payload[this.checkIsProfile(checkForm.field_profile_type_id)] =
            checkForm.other_value;
      }

      // payload.custom_field = dynamic;
      let hasBirthDay = this.customField.find(
        el => el.field_profile_type_id == 9
      );

      if (hasBirthDay && this.yearFormat == 1)
        if (payload.birthday_year)
          payload.birthday_year = moment(
            `${payload.birthday_day}/${payload.birthday_month}/${payload.birthday_year}`,
            "DD/MM/YYYY"
          )
            .subtract(543, "y")
            .year();
      if (!payload.birthday_day) payload.birthday_day = "01";
      if (!payload.birthday_month) payload.birthday_month = "01";
      if (!payload.birthday_year) payload.birthday_year = "1753";
      payload.social = this.socialField.map(el => {
        return {
          // ...el,
          id: el.answer_id || 0,
          social_media_type_id: el.id,
          value: el.user_answer,
          user_guid: payload.user_guid
        };
      });

      try {
        const data = await this.$axios.post(
          `/api/v1/user/EditUserProfile`,
          payload
        );

        if (data.result == 1) {
          if (this.customField.length > 0) {
            await this.updateCustomField();
          } else {
            // this.$store.dispatch("refreshUserProfile");
            if (!this.componentKey) this.$router.push("/profile");
            this.$emit("onFinish");
          }
        } else {
          this.disabledBtn = false;
          if (data.detail[0]) {
            this.successMessage = data.detail[0];
          } else {
            this.successMessage = data.message;
          }
          this.$refs.modalError.show();
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error.message);
        this.disabledBtn = false;

        this.successMessage = "เกิดข้อผิดพลาดไม่สามารถแก้ไขข้อมูลได้";

        this.$refs.modalError.show();
        this.isLoading = false;
      }
    },
    async updateCustomField() {
      let body = {
        user_guid: this.form.user_guid,
        admin_user_guid: this.form.user_guid,
        question_list: this.questionList
      };
      const data = await this.$axios.put(
        `/api/v1/User/update_custom_answer`,
        body
      );

      if (data.result == 1) {
        if (!this.componentKey) this.$router.push("/profile");
        this.isLoading = false;
        this.$emit("onFinish");
      } else {
        this.disableBtn = false;
        this.isLoading = false;
        if (data.detail[0]) {
          this.successMessage = data.detail[0];
        } else {
          this.successMessage = data.message;
        }
        this.$refs.modalError.show();
      }
    },
    modalPolicyOpen(flag = true) {
      if (this.$store.state.theme.is_custom_privacy_link == "1" && flag)
        return window.open(this.$store.state.theme.consent_url_link, "_blank");
      this.emitter.emit("showModal", "policy");
    },
    modalTermsOpen(flag = true) {
      if (this.$store.state.theme.is_term_and_con_url == "1" && flag)
        return window.open(this.$store.state.theme.term_and_con_url, "_blank");
      this.emitter.emit("showModal", "term");
    },
    async getCustomObjectForm() {
      const resp = await this.$axios.post(
        `/api/CustomObject/custom_object_head`,
        {
          user_guid: "" // อันนี้ของหน้า customer detail
        }
      );

      this.customObjectForm = resp.detail;
    },
    handleTabsChange(name) {
      this.tabsName = name;
      if (this.$route.query.view)
        return this.$router.replace(`/manage/profile?check=true`);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .content-edit-profile {
  // background-color: #fff;
  border-radius: 5px;
  // height: 80vh;

  // margin-bottom: 65px;
}

.btn-edit {
  background-color: #000;
  color: #fff;
  width: 100%;
  border: none;
  padding: 10px 0;
}
.remark {
  color: red;
}

.custom-pd-tel {
  padding: 0 10px;
}
.footer-bottom {
  max-width: 800px;
  position: fixed;
  margin: auto;
}
.consent-text {
  font-size: var(--text-2xl);
  color: #575757;
}
.text-underline {
  text-decoration: underline;
}
.div-space {
  margin: 90px 0px;
  background-color: #fff;
}
.label-text {
  color: black;
  font-size: var(--text-2xl);
  margin-bottom: 5px;
  font-weight: 600;
  // color: #838383;
}
.tabs-with-button {
  // height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 227px);
}

.container-tabs {
  // height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 167px);
}

::v-deep .nav {
  width: max-content;
  flex-wrap: unset;
}
::v-deep .nav-wrapper {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
::v-deep .v-window-item.window-padding {
  padding-bottom: 95px;
}
</style>
